/* ============================================================
   NORTHSHEEP — the grid changes its mind without blinking

   Owner, 20 Sep 2026: "yes fix it to make it more fluent and better".

   Dawn applies a sort, a filter or a colour pill by replacing the whole of
   #ProductGridContainer's innerHTML in one go, so for a moment the container
   is EMPTY. Left alone that reads as the page breaking: the cards vanish, the
   container collapses, everything below jumps up, and then it all springs
   back as the new cards paint.

   So the height it already had is pinned across the swap and the old cards
   fade down rather than vanishing, which turns a flash into a change.

   WHAT THIS FILE NO LONGER DOES, and this is the point of it being short.

   It used to also reserve room for the lazy-loaded second batch — a spacer
   div, a height claim on <html>, a release rule, instrumentation for when
   that release went wrong. None of it worked reliably, because it was
   correcting the page's height from JavaScript AFTER the browser had already
   decided where to put the scroll.

   That job moved to the server: main-collection-product-grid.liquid renders
   the rows the second batch will occupy, so the document is its full length
   in the first byte. Nothing here has to prop anything up, and the scroll
   position belongs to assets/ns-grid-restore.js — one owner each, which is
   what this theme was missing.

   WHERE IT HOOKS IN
   Dawn funnels every one of those routes — a checkbox, the sort dropdown, a
   colour pill, "Remove all" — through FacetFiltersForm.renderPage. Wrapping
   that one function covers all of them, and anything added later, without
   listening for a single click.
   ============================================================ */
(function () {
  'use strict';
  if (window.__nsGridFade) return;
  window.__nsGridFade = true;

  var HOLD_CLASS = 'ns-grid-swapping';
  var releaseTimer = 0;

  function container() {
    return document.getElementById('ProductGridContainer');
  }

  function begin() {
    var box = container();
    if (!box) return;
    /* Measured BEFORE the swap, which is the whole point: once innerHTML is
       gone there is nothing left to measure. */
    var h = box.getBoundingClientRect().height;
    if (h > 0) box.style.minHeight = Math.round(h) + 'px';
    box.classList.add(HOLD_CLASS);
    window.clearTimeout(releaseTimer);
    /* A safety net: if the fetch fails or Dawn renders nothing, the grid must
       not be left faded and propped open. */
    releaseTimer = window.setTimeout(function () {
      end(99);
    }, 4000);
  }

  function end(retry) {
    var box = container();
    if (!box) return;
    window.clearTimeout(releaseTimer);
    box.classList.remove(HOLD_CLASS);

    var grid = document.getElementById('product-grid');
    if (!grid || !grid.children.length) {
      /* The container is momentarily empty mid-swap — an earlier version
         cleared the prop on exactly that record and collapsed the page. But
         not for ever: a filter that matches nothing renders an empty state
         with no grid at all, and holding the old height there would leave a
         screen of white above the footer. */
      var n = (retry || 0) + 1;
      if (n < 10) {
        window.setTimeout(function () {
          end(n);
        }, 60);
        return;
      }
    }
    box.style.minHeight = '';
  }

  /* The swap has landed when the container's children change. */
  function watch() {
    var box = container();
    if (!box || !window.MutationObserver) return;
    new MutationObserver(function () {
      if (box.classList.contains(HOLD_CLASS)) end(0);
    }).observe(box, { childList: true });
  }

  function hook() {
    if (typeof FacetFiltersForm === 'undefined' || !FacetFiltersForm.renderPage) return false;
    if (FacetFiltersForm.renderPage.__nsWrapped) return true;
    var original = FacetFiltersForm.renderPage;
    var wrapped = function () {
      try {
        begin();
      } catch (e) {}
      return original.apply(this, arguments);
    };
    wrapped.__nsWrapped = true;
    FacetFiltersForm.renderPage = wrapped;
    return true;
  }

  function start() {
    watch();
    /* facets.js is deferred like this file and may define the class after it.
       A few attempts across the first second cover every load order without
       leaving a timer running. */
    if (hook()) return;
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (hook() || tries > 10) clearInterval(t);
    }, 100);
  }

  if (document.readyState === 'complete') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
